/**
 * Application Constants
 */

// GB Location Settings
export const LOCALE = 'en-GB';
export const TIMEZONE = 'Europe/London';
export const CURRENCY = 'GBP';
export const CURRENCY_SYMBOL = '£';

// Auth0 Namespace
export const AUTH0_NAMESPACE = 'https://booking-slot.com';

// User Roles
export const ROLES = {
  SERVICEPROVIDER: 'ServiceProvider',
  SERVICEUSER: 'ServiceUser',
  ADMIN: 'admin'
};

// Days of Week
export const DAYS_OF_WEEK = [
  'Sunday',
  'Monday', 
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
];

// Slot Duration Options (minutes)
export const SLOT_DURATIONS = [
  { value: 10, label: '10 minutes' },
  { value: 15, label: '15 minutes' },
  { value: 30, label: '30 minutes' },
  { value: 60, label: '1 hour' },
  { value: 90, label: '1.5 hours' },
  { value: 120, label: '2 hours' },
  { value: 150, label: '2.5 hours' },
  { value: 180, label: '3 hours' }
];

// Break Duration Options (minutes)
export const BREAK_DURATIONS = [
  { value: 0, label: 'No break' },
  { value: 15, label: '15 minutes' },
  { value: 30, label: '30 minutes' },
  { value: 45, label: '45 minutes' },
  { value: 60, label: '60 minutes' }
];

// Default Settings
export const DEFAULT_SETTINGS = {
  DATE_RANGE_MONTHS: 2,
  DEFAULT_START_TIME: '08:00',
  DEFAULT_END_TIME: '18:00',
  DEFAULT_SLOT_DURATION: 120,
  DEFAULT_BREAK_DURATION: 0,
  DEFAULT_DAYS_IN_ADVANCE: 14,
  DEFAULT_DAY_FROM: 'Monday',
  DEFAULT_DAY_TO: 'Friday'
};